import {
  Account,
  AccountSignupSource,
  AccountSubscriptionStatus,
  AccountType,
  Scanner,
  ScannerManufacturer,
  User,
  UserRole,
  UserStatus
} from '@api/types';
import { DocumentSource } from '@api/types/document';

export const emptyDocument = {
  account_id: '',
  control_number: '',
  created_at: '',
  deleted_at: '',
  description: '',
  favorite: false,
  id: '',
  shared_at: '',
  source: DocumentSource.Scanner,
  template_name: '',
  title: '',
  updated_at: '',
  version: 0,
  viewed_at: ''
};

export const emptyAccount: Account = {
  card_brand: '',
  card_last_four: '',
  city: '',
  country: '',
  created_at: '',
  document_count: 0,
  email: '',
  id: '',
  incoming_email: '',
  incoming_fax: '',
  last_activity: '',
  name: '',
  payment: '',
  phone_number: '',
  postal_code: '',
  signup_source: AccountSignupSource.Scanner,
  state: '',
  street1: '',
  street2: '',
  subscription_plan: '',
  subscription_status: AccountSubscriptionStatus.None,
  type: AccountType.Basic,
  updated_at: '',
  trial_ends_at: ''
};

export const emptyUser: User = {
  account_id: '',
  country_code: '',
  created_at: '',
  email: '',
  enable_2fa: false,
  first_name: '',
  id: '',
  last_activity: '',
  last_name: '',
  phone_number: '',
  role: UserRole.Owner,
  status: UserStatus.Pending,
  updated_at: ''
};

export const emptyScanner: Scanner = {
  account_id: '',
  created_at: '',
  id: '',
  last_login: '',
  manufacturer: ScannerManufacturer.Unknown,
  notes: '',
  status: ''
};

export const documentSearchFields = {
  control_number: 'Control Number',
  created_at: 'Created',
  description: 'Description',
  shared_at: 'Shared',
  source: 'Source',
  template_id: 'Template Name',
  title: 'Title',
  updated_at: 'Updated',
  version: 'Version',
  viewed_at: 'Viewed At',
  template_data: 'Template Data',
  document_tag_ids: 'Tags'
};
